// Modules
import axios from 'axios';
import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

// CSS
import '_Asset/css/Admin/Page/admin.css'

// Component
import { Pagination } from 'User/Component';
import {
  Paging, // Paging
  CurPageList, // 전체 리스트 정렬 및 현재 페이지 리스트 출력
  SetSortIco, // 정렬 아이콘 변경
} from 'Admin/Component/AdFunc';

// API
import { MemApi, MemUseApi } from '_Route/Api';
import Loading from 'Admin/Component/Loading';


const AdMem = () => {

  // Using Hooks
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [guideStatus, setGuideStatus] = useState(true);
  const [accData, setAccData] = useState({
    pageList: [], // ACC Page List
    resList: [], // ACC Result List
  })
  const { pageList, resList } = accData

  const sessionID = localStorage.getItem('memSessionID')
  const userScore = useSelector(state => state.authorityAcc.access_score);
  const master = useSelector(state => state.authorityAcc.master);
  
  // Paging var
  const [curPage, setCurPage] = useState(1) // 현제 페이지
  const blockSize = 10 // Pagination 블럭 갯수
  const [pageSize, setPageSize] = useState(10) // 한 페이지에 노출할 회원 갯수
  const [count, setCount] = useState('');

  // 필터 옵션
  const [filterOpt, setFilterOpt] = useState({
    search_key: '',
    search_val: params.key || '',
    acc_roles: '',
    access_score: '',
    fjoin: '',
    ljoin: '',
  })
  const { search_key, search_val, acc_roles, access_score, fjoin, ljoin } = filterOpt;

  // Column name / Sort var
  const columnList = [
    {name: 'No', key: 'acc_no'},
    {name: '소속 회사', key: 'company_name'}, 
    {name: '이메일', key: 'email'},
    {name: '이름', key: 'name'},
    {name: '휴대폰 번호', key: 'phone_number'},
    {name: '관리 권한', key: 'acc_roles'},
    {name: '권한 점수', key: 'access_score'}, // 100 (Readonly), 200 (Add), 300 (Modify / Delete)
    {name: '회사 도메인', key: 'company_domain'},
    {name: '접속 IP', key: 'acc_ip'},
    {name: '등록일', key: 'fjoin'},
    {name: '최근 접속일', key: 'ljoin'},
    {name: '수정', key: 'use', access_score: 300},
  ]; 
  
  const [sortIdx, setSortIdx] = useState(0);
  const [sortType, setSortType] = useState('');
  const [sortState, setSortState] = useState('expand'); // expand, up(DECS), down(ASC);


  /*========================================================================
  * onHandler Func
  ========================================================================*/
  const onFilter = (e) => {
    const { name, value } = e.target;
    setFilterOpt({...filterOpt, [name]: value});
  }

  const onKeyPress = (e) => { if(e.key == 'Enter') onSearch(); }
  const onSearch = () => {
    navigate(`/admin/member-mgt/list${search_val === '' ? '' : '/' + encodeURIComponent(search_val)}`);
  }

  const onJSON = (data) => {
    try {
      const parseData = JSON.parse(data)
      let resData = '';
      parseData?.map((r, i) => {
        resData += (parseData.length === i + 1) ? r : r + ', '
      })
      return resData;
    }
    catch (err) {
      return data
    }
  }


  /* ========================================================================
  * Axios ACC
  ========================================================================*/
  // GET ACC List
  useEffect(() => {
    setLoading(false)
    axios.get(MemApi, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      params: filterOpt
    })
    .then(res => {
      console.log("GET ACC List Success!", res);
      const sortData = res.data.result;
      
      accData.pageList = res.data.pageInfo
      accData.resList = CurPageList(sortData, sortType, sortState, curPage, pageSize)
      setAccData({...accData})
      setCount(res.data.result.length);
    })
    .catch(err => {
      console.error("GET ACC List ERROR...", err);
    })
    .finally(() => {
      setLoading(true)
    })
  }, [location, pageSize, curPage, sortState, sortIdx, search_key, acc_roles, access_score, fjoin, ljoin])

  // 회원 사용/미사용 처리
  const UpdateACC = (accUuid) => {
    console.log(accUuid,"accUuid")
    axios({
      url: MemUseApi,
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: {
        uid: accUuid,
        approve_spec_status: 0,
        approve_ap_status: 0,
      }
    })
    .then(res => {
      alert(`회원 사용 여부 변경${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
    })
    .catch(err => {
      console.error("PUT Member Use Error...", err);
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }


  return (
    <>
      <div className="adContTitGroup">
        <h2>관리자 회원 관리</h2>
        <p>Home / 관리자 회원 관리 <button type="button" onClick={() => setGuideStatus(!guideStatus)}><i className="icofont-info-circle" /> 가이드 {guideStatus ? '접기' : '보기'} <i className={`icofont-rounded-${guideStatus ? 'up' : 'down'}`} /></button></p>

        <ul className={`subMsg ${guideStatus ? '' : 'off'}`}>
          <li>* 개발자 Portal Admin에 로그인한 회원의 Seyfert 인증센터 계정 정보를 <span className="blueTxt">조회/검색</span>할 수 있습니다.</li>
          <li>* Access Score 기준: <span className="blueTxt">100(Read Only) - 200(Add) - 300(Modify/Delete)</span></li>
        </ul>
      </div>

      <div className="adContArea list">

        <div className="flexBox between">
          <div className="adListBox">
            <div className="fieldGroup">
              <label>노출 회원 수</label>

              <div className="field">
                <select name="" className="select sm type_1 round_10" onChange={(e) => setPageSize(e.target.value)} defaultValue="10">
                  <option value="10">10개 씩</option>
                  <option value="30">30개 씩</option>
                  <option value="50">50개 씩</option>
                  <option value="100">100개 씩</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>관리 권한</label>

              <div className="field">
                <select className="select sm type_1 round_10" name="acc_roles" onChange={(e) => onFilter(e)}>
                  <option value="">전체 권한</option>
                  <option value="ADMIN">ADMIN (페이게이트 시스템 관리자)</option>
                  <option value="PGADMIN">PGADMIN (페이게이트 관리자)</option>
                  <option value="PGUSER">PGUSER (페이게이트 임직원)</option>
                  <option value="CADMIN">CADMIN (회원사 관리자)</option>
                  <option value="CUSER">CUSER (회원사 임직원)</option>
                  <option value="WAIT">WAIT (가입 대기 회원)</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>권한 점수</label>

              <div className="field">
                <select className="select sm type_1 round_10" name="access_score" onChange={(e) => onFilter(e)}>
                  <option value="">전체 점수</option>
                  <option value="100">100 (Read Only)</option>
                  <option value="200">200 (Add)</option>
                  <option value="300">300 (Modify / Delete)</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>등록일</label>

              <div className="field">
                <select className="select sm type_1 round_10" name="fjoin" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  <option value="to">오늘</option>
                  <option value="day">어제</option>
                  <option value="week">최근 1주일</option>
                  <option value="month">최근 1개월</option>
                  <option value="year">최근 1년</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>최근 접속일</label>

              <div className="field full">
                <select className="select sm type_1 round_10" name="ljoin" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  <option value="to">오늘</option>
                  <option value="day">어제</option>
                  <option value="week">최근 1주일</option>
                  <option value="month">최근 1개월</option>
                  <option value="year">최근 1년</option>
                </select>
              </div>
            </div>
          </div>

          <div className="adListBox">
            <div className="fieldGroup row gap">
              <label>회원 검색</label>

              <div className="field gap">
                <select className="select sm type_1 round_10" name="search_key" onChange={(e) => onFilter(e)}>
                  <option value="">통합검색</option>
                  <option value="company_name">소속 회사</option>
                  <option value="email">이메일</option>
                  <option value="name">이름</option>
                  <option value="phone_number">휴대폰 번호</option>
                  <option value="company_domain">회사 도메인</option>
                  <option value="ip">접속 IP</option>
                </select>
                <div className="inputIco">
                  <input type="text" className="input sm type_1 i_rt round_10" name="search_val" value={search_val} onChange={(e) => onFilter(e)} onKeyPress={onKeyPress} placeholder="검색어를 입력해주세요." />
                  <button type="button" className="icofont-search" onClick={onSearch}></button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="table list_2">
          <table>
            <thead>
              <tr>
                {columnList.map((list, i) =>
                  (userScore >= list?.access_score || list.access_score === undefined) &&
                  <th key={i} onClick={() => {setSortState(SetSortIco(i, sortIdx, sortState)); setSortIdx(i); setSortType(list.key)}}>{list.name}<i className={`icofont-rounded-${i === sortIdx ? sortState : 'expand'}`}></i></th>
                )}
              </tr>
            </thead>
            <tbody>
              {loading ?
                resList.length !== 0 ?
                  resList.map((data, i) => 
                    <tr key={i}>
                      <td>{data.acc_no}</td>
                      <td>{data.company_name}</td>
                      <td>{data.email}</td>
                      <td>{data.name}</td>
                      <td>{data.phone_number}</td>
                      <td>{onJSON(data.acc_roles)}</td>
                      <td>{data.access_score}</td>
                      <td>{data.company_domain}</td>
                      <td>{onJSON(data.ip)}</td>
                      <td>{moment(data.fjoin).format('YYYY-MM-DD HH:mm')}</td>
                      <td>{data.ljoin === null ? '-' : moment(data.ljoin).format('YYYY-MM-DD HH:mm')}</td>
                      {
                        userScore >= 300 &&
                        <td style={{width: '125px'}}>
                          <div className="btnArea col full">
                            <button type="button" className={`btn xxs ${data?.use === 'Y' ? 'sfrtBlue' : 'blue_edge'} round_10`} onClick={() => UpdateACC(data.uid)}>{data?.use === 'Y' ? '사용' : '미사용'}</button>
                          </div>
                        </td>
                      }
                    </tr>
                  )
                  :
                  <tr>
                    <td colSpan={columnList.length + 1}>
                      <div className="noData">
                        <i className="icofont-warning-alt"></i>
                        <p>데이터가 존재하지 않습니다.</p>
                      </div>
                    </td>
                  </tr>
                :
                <tr><td colSpan={columnList.length + 1}><Loading type="tbLoad" /></td></tr>
              }
            </tbody>
          </table>
        </div>

        <div className="flexBox between paginationBox">
          <p>Showing {curPage} to {pageSize} of {pageList.count} entries</p>

          <Pagination
            type="type_1"
            size="sm"
            curPage={curPage}
            setCurPage={setCurPage}
            pageSize={pageSize}
            blockSize={blockSize}
            startBlock={Paging(curPage, blockSize, pageSize, count).startBlock}
            endBlock={Paging(curPage, blockSize, pageSize, count).endBlock}
            pageCount={Paging(curPage, blockSize, pageSize, count).pageCount}
          />
        </div>
      </div>
    </>
  )
}

export default AdMem;